import { Empty, Row } from "antd";
import { Loader } from "../../../../../components/Loader";
import { Item } from "./Item";

type ItemListProps = {
  items: any[];
  isLoading: boolean;
  setPaymentRecord: React.Dispatch<React.SetStateAction<any>>;
  setPage: React.Dispatch<React.SetStateAction<string>>;
};

export const ItemList = ({
  items,
  isLoading,
  setPaymentRecord,
  setPage,
}: ItemListProps) => {
  return (
    <Row className="justify-center w-100 pt-7 overflow-y-hidden">
      {isLoading ? (
        <Row className="w-100 justify-center h-100">
          <Loader fontSize="64px" />
        </Row>
      ) : (
        <>
          {items.length > 0 ? (
            items.map((item: any) => (
              <Item
                values={item}
                key={item.id}
                setPaymentRecord={setPaymentRecord}
                setPage={setPage}
              />
            ))
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </>
      )}
    </Row>
  );
};
